import { render, staticRenderFns } from "./SchoolType.vue?vue&type=template&id=5e78ea6e&"
import script from "./SchoolType.vue?vue&type=script&lang=js&"
export * from "./SchoolType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports